import { render } from "./SideBarMenuLv3.vue?vue&type=template&id=47979d63&scoped=true"
import script from "./SideBarMenuLv3.vue?vue&type=script&lang=js"
export * from "./SideBarMenuLv3.vue?vue&type=script&lang=js"

import "./SideBarMenuLv3.vue?vue&type=style&index=0&id=47979d63&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47979d63"]])

export default __exports__